import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6962de50"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = {
  key: 0,
  class: "meta"
}
const _hoisted_3 = {
  key: 0,
  class: "author"
}

import { IArticle } from '@/types/article';

  interface IProps {
    article: IArticle;
    showMeta?: boolean;
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    article: null,
    showMeta: { type: Boolean }
  },
  setup(__props: any) {

  

return (_ctx: any,_cache: any) => {
  const _component_AppTimeFormat = _resolveComponent("AppTimeFormat")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    exact: "",
    to: { name: 'faq.article', params: { id: __props.article.faq_section_id, slug: __props.article.slug } }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(__props.article.title), 1),
      (__props.showMeta)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (__props.article.author)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.article.author), 1))
              : _createCommentVNode("", true),
            _createElementVNode("span", null, [
              _createVNode(_component_AppTimeFormat, {
                time: __props.article.updated_at,
                format: "YYYY.MM.DD HH:mm"
              }, null, 8, ["time"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})